// FROZEN default icon assets (§3.6). Image encoders are nondeterministic (embedded
// timestamps/metadata), so the builder MUST NOT generate raster icons on the fly — it embeds
// these fixed bytes verbatim. These are real default icons: a full-bleed indigo square with a
// centered "browser window" mark (purple title bar over a light panel), rendered at 192x192 and
// 512x512 as deterministic truecolor (RGB, PNG color type 2, no metadata chunks). They are shown
// only when a publisher supplies no icons of their own. Regenerate deterministically with
// `node packages/core/scripts/gen-default-icons.mjs` if the art changes — doing so is an
// intentional, versioned change that MODIFIES THE TEST VECTORS (root CIDs), since these bytes hash
// into every default-icon site.
//
// Bytes are inlined (not read from disk) so `build` stays pure and filesystem-free (§3.7).

// prettier-ignore
const ICON_192_PNG = new Uint8Array([
  137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, 0, 0, 0, 192,
  0, 0, 0, 192, 8, 2, 0, 0, 0, 221, 190, 251, 80, 0, 0, 1, 199, 73, 68, 65,
  84, 120, 218, 237, 210, 177, 17, 0, 16, 20, 68, 65, 29, 201, 213, 242, 75, 81, 167, 74,
  68, 34, 13, 136, 204, 8, 176, 51, 175, 130, 187, 77, 37, 135, 180, 93, 50, 129, 0, 18,
  64, 2, 72, 0, 73, 0, 9, 32, 1, 36, 128, 36, 128, 4, 144, 0, 18, 64, 18, 64,
  2, 72, 0, 9, 32, 9, 32, 1, 36, 128, 4, 144, 0, 146, 0, 18, 64, 2, 72, 0,
  73, 0, 9, 32, 1, 36, 128, 36, 128, 4, 144, 0, 18, 64, 18, 64, 2, 72, 0, 9,
  32, 1, 36, 1, 36, 128, 4, 144, 0, 146, 0, 18, 64, 2, 104, 89, 141, 166, 67, 1,
  36, 128, 0, 2, 8, 32, 128, 0, 2, 8, 32, 1, 4, 16, 64, 0, 1, 4, 16, 64,
  0, 9, 32, 128, 0, 2, 8, 32, 128, 0, 2, 72, 0, 9, 32, 128, 0, 2, 8, 32,
  128, 4, 144, 0, 2, 8, 32, 128, 0, 2, 8, 160, 151, 1, 245, 62, 116, 40, 128, 4,
  16, 64, 0, 1, 4, 16, 64, 0, 1, 36, 128, 0, 2, 8, 32, 128, 0, 2, 8, 32,
  1, 4, 16, 64, 0, 1, 4, 16, 64, 0, 9, 32, 1, 4, 16, 64, 0, 1, 4, 144,
  0, 18, 64, 0, 1, 4, 16, 64, 0, 1, 4, 144, 0, 2, 8, 32, 128, 0, 2, 8,
  32, 128, 4, 16, 64, 0, 1, 4, 16, 64, 0, 1, 36, 128, 4, 16, 64, 0, 1, 4,
  16, 64, 2, 72, 0, 1, 4, 16, 64, 0, 1, 4, 16, 64, 2, 8, 32, 128, 0, 2,
  8, 32, 128, 0, 18, 64, 0, 1, 4, 16, 64, 0, 1, 4, 144, 0, 114, 51, 64, 0,
  1, 4, 16, 64, 0, 9, 32, 1, 4, 16, 64, 0, 1, 4, 144, 0, 18, 64, 0, 1,
  4, 16, 64, 0, 1, 4, 144, 0, 2, 8, 32, 128, 0, 2, 8, 32, 128, 4, 16, 64,
  0, 1, 4, 16, 64, 0, 1, 36, 128, 4, 16, 64, 0, 1, 4, 16, 64, 2, 72, 0,
  1, 4, 16, 64, 0, 1, 4, 16, 64, 2, 72, 63, 4, 144, 0, 18, 64, 2, 72, 0,
  73, 0, 9, 32, 1, 36, 128, 36, 128, 4, 144, 0, 18, 64, 18, 64, 2, 72, 0, 9,
  32, 9, 32, 1, 36, 128, 4, 144, 0, 146, 0, 18, 64, 2, 72, 0, 73, 0, 9, 32,
  1, 36, 128, 36, 128, 4, 144, 0, 18, 64, 18, 64, 2, 72, 0, 9, 32, 1, 36, 1,
  36, 128, 4, 144, 0, 146, 0, 18, 64, 186, 162, 9, 163, 28, 159, 15, 96, 218, 163, 135,
  0, 0, 0, 0, 73, 69, 78, 68, 174, 66, 96, 130,
]);

// prettier-ignore
const ICON_512_PNG = new Uint8Array([
  137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, 0, 0, 2, 0,
  0, 0, 2, 0, 8, 2, 0, 0, 0, 123, 26, 67, 173, 0, 0, 8, 80, 73, 68, 65,
  84, 120, 218, 237, 213, 49, 13, 0, 32, 12, 69, 193, 58, 98, 71, 75, 165, 160, 19, 37,
  76, 76, 88, 96, 108, 210, 75, 78, 193, 79, 218, 23, 115, 36, 0, 13, 133, 9, 0, 4,
  0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0,
  0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0,
  16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64,
  0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0,
  0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0,
  64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0,
  1, 0, 64, 0, 0, 4, 192, 10, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0,
  2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8,
  0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0,
  0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0,
  8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32,
  0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0,
  0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 2, 96, 5, 0, 1,
  0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0,
  0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0,
  4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16,
  0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 232, 109, 229, 6, 10, 242,
  157, 4, 64, 0, 64, 0, 16, 0, 1, 0, 1, 64, 0, 4, 0, 4, 0, 1, 16, 0,
  16, 0, 4, 64, 0, 64, 0, 4, 0, 1, 0, 1, 16, 0, 4, 0, 4, 64, 0, 16,
  0, 16, 0, 1, 64, 0, 64, 0, 4, 64, 0, 92, 26, 8, 128, 0, 8, 0, 32, 0,
  2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8, 0, 32,
  0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8, 0,
  32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8,
  0, 32, 0, 2, 32, 0, 32, 0, 8, 128, 0, 128, 0, 32, 0, 2, 0, 2, 128, 0,
  8, 0, 8, 0, 2, 32, 0, 32, 0, 2, 96, 5, 1, 0, 1, 16, 0, 4, 0, 4,
  64, 0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 0, 1, 0, 1, 16, 0, 1, 0,
  4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0, 1,
  0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0,
  1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16,
  0, 1, 0, 4, 64, 0, 4, 0, 4, 192, 131, 18, 0, 1, 0, 1, 64, 0, 4, 0,
  4, 0, 1, 16, 0, 16, 0, 4, 64, 0, 64, 0, 16, 0, 1, 0, 1, 16, 0, 4,
  0, 4, 64, 0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 0, 1, 0, 1, 16, 0,
  1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 104, 227, 156, 11, 20, 228, 59, 9, 128, 0,
  128, 0, 32, 0, 2, 0, 2, 128, 0, 8, 0, 8, 0, 2, 32, 0, 32, 0, 8, 128,
  0, 128, 0, 8, 0, 2, 0, 2, 32, 0, 8, 0, 8, 128, 0, 32, 0, 32, 0, 2,
  128, 0, 128, 0, 8, 128, 0, 184, 52, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0,
  1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0,
  0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64,
  0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4,
  64, 0, 64, 0, 16, 0, 1, 0, 1, 64, 0, 4, 0, 4, 0, 1, 16, 0, 16, 0,
  4, 64, 0, 64, 0, 4, 192, 10, 2, 0, 2, 32, 0, 8, 0, 8, 128, 0, 32, 0,
  32, 0, 2, 128, 0, 128, 0, 8, 0, 2, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8,
  0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0,
  8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128,
  0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8,
  128, 0, 8, 0, 8, 128, 7, 37, 0, 2, 0, 2, 128, 0, 8, 0, 8, 0, 2, 32,
  0, 32, 0, 8, 128, 0, 128, 0, 32, 0, 2, 0, 2, 32, 0, 8, 0, 8, 128, 0,
  32, 0, 32, 0, 2, 128, 0, 128, 0, 8, 0, 2, 0, 2, 32, 0, 2, 0, 8, 128,
  0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8,
  128, 0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0,
  8, 128, 0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2,
  0, 8, 128, 0, 8, 0, 32, 0, 2, 32, 0, 32, 0, 8, 128, 0, 128, 0, 32, 0,
  2, 0, 2, 128, 0, 8, 0, 8, 0, 2, 32, 0, 32, 0, 2, 96, 5, 1, 0, 1,
  16, 0, 4, 0, 4, 64, 0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 0, 1, 0,
  1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0,
  0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64,
  0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4,
  64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 4, 192, 131, 18, 0, 1, 0,
  1, 64, 0, 4, 0, 4, 0, 1, 16, 0, 16, 0, 4, 64, 0, 64, 0, 16, 0, 1,
  0, 1, 16, 0, 4, 0, 4, 64, 0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 0,
  1, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4,
  64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0,
  4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64,
  0, 4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0,
  16, 0, 4, 64, 0, 64, 0, 16, 0, 1, 0, 1, 64, 0, 4, 0, 4, 0, 1, 16,
  0, 16, 0, 1, 64, 0, 64, 0, 4, 0, 1, 0, 1, 16, 0, 4, 0, 4, 64, 0,
  16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64,
  0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0, 1, 0, 4,
  64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0, 1, 0,
  4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0, 4, 64, 0, 0, 1, 16, 0, 1,
  0, 1, 64, 0, 4, 0, 4, 0, 1, 16, 0, 16, 0, 4, 64, 0, 64, 0, 16, 0,
  1, 0, 1, 64, 0, 4, 0, 4, 64, 0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4,
  0, 1, 0, 1, 16, 0, 4, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64, 0,
  4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0, 64,
  0, 4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16, 0,
  64, 0, 4, 64, 0, 0, 1, 16, 0, 1, 0, 4, 64, 0, 4, 0, 16, 0, 1, 16,
  0, 64, 0, 4, 64, 0, 64, 0, 16, 0, 1, 0, 1, 64, 0, 4, 0, 4, 0, 1,
  16, 0, 16, 0, 4, 64, 0, 64, 0, 4, 0, 1, 0, 1, 16, 0, 4, 0, 4, 64,
  0, 16, 0, 16, 0, 1, 64, 0, 64, 0, 4, 0, 103, 6, 2, 32, 0, 2, 0, 8,
  128, 0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0,
  8, 128, 0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0, 2,
  0, 8, 128, 0, 8, 0, 32, 0, 2, 32, 0, 128, 0, 8, 128, 0, 0, 2, 32, 0,
  2, 0, 8, 128, 0, 8, 0, 8, 0, 2, 32, 0, 32, 0, 8, 128, 0, 128, 0, 32,
  0, 2, 0, 2, 128, 0, 8, 0, 8, 0, 2, 32, 0, 32, 0, 2, 128, 0, 128, 0,
  8, 0, 2, 0, 2, 32, 0, 8, 0, 8, 128, 0, 32, 0, 32, 0, 2, 32, 0, 128,
  0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8, 0, 32, 0, 2, 32, 0,
  128, 0, 8, 128, 0, 0, 2, 32, 0, 2, 0, 8, 128, 0, 8, 0, 32, 0, 2, 32,
  0, 128, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128,
  0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0,
  0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0,
  128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0,
  2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 32, 0, 38, 0, 16, 0, 0,
  4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16,
  0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0,
  0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0,
  16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64,
  0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1,
  0, 64, 0, 0, 16, 0, 0, 4, 0, 0, 1, 0, 64, 0, 0, 16, 0, 0, 4, 0,
  0, 1, 0, 16, 0, 43, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0,
  0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0,
  8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32,
  0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0,
  0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0,
  32, 0, 0, 8, 0, 0, 2, 0, 128, 0, 0, 32, 0, 0, 8, 0, 0, 2, 0, 128,
  0, 0, 240, 237, 1, 224, 57, 58, 134, 95, 196, 25, 163, 0, 0, 0, 0, 73, 69, 78,
  68, 174, 66, 96, 130,
]);

export const DEFAULT_ICON_192 = { path: "/icon-192.png", bytes: ICON_192_PNG, sizes: "192x192" };
export const DEFAULT_ICON_512 = { path: "/icon-512.png", bytes: ICON_512_PNG, sizes: "512x512" };
